import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-model',
  templateUrl: './list-model.component.html',
  styleUrls: ['./list-model.component.scss']
})
export class ListModelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
